let ModulesPromo = [
  {
    path: '/PromoLogin',
    name: 'PromoLogin',
    component: () => import('@/views/php/PromoLogin.vue')
  },  
];
  
export default ModulesPromo;